<template>
  <div class="discount_content">
    <titlebar titleName="限时折扣" goback="true"></titlebar>
    <div class="content">
        <img class="banner" src="../../assets/images/xszk.png" alt="">

        <ul class="list">
            <li class="item" v-for="(item,index) in 4" :key="index">
                <div class="left">
                    <div class="img"></div>
                    <div class="info">
                        <p class="name">浩天奇缘</p>
                        <div class="tag">
                            <p>福利</p>
                            <p>优惠券</p>
                        </div>
                        <p class="zk">4.3折</p>
                    </div>
                </div>
                <div class="btn">
                    下载
                </div>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>
import titlebar from "../../components/index/titleBar.vue";
export default {
  components: {
    titlebar,
  },
};
</script>

<style lang="less"  scoped>
.discount_content{
    overflow: hidden;
    .content{
        padding-top: 13vw;
        .banner{
            width: 92vw;
            height: 26.8vw;
            margin: 0 auto;
        }
        .list{
           margin-top: 3vw;
            .item{
                margin: 0 auto;
                width: 92.1333vw;
                height: 23.0667vw;
                background: #fff;
                border-radius: 3vw;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 3.0667vw;
                color: #000;
                margin-bottom: 3vw;
                .left{
                    display: flex;
                    align-items: center;
                    .img{
                        width: 17.3333vw;
                        height: 17.3333vw;
                        background: #000;
                        border-radius: 3vw;
                        margin-right: 2vw;
                    }
                    .info{
                        text-align: left;
                        .name{
                            font-size: 3.5vw;
                            font-weight: 600;
                        }
                        .tag{
                            display: flex;
                            align-items: center;
                            color: #fff;
                            margin: 2vw 0;
                            p{
                                background: red;
                                font-size: 3vw;
                                border-radius: 1vw;
                                margin-right: 1vw;
                                padding: 0.5vw;
                            }
                        }
                        .zk{
                            font-size: 3.5vw;
                            color: red;
                            font-weight: 600;
                        }
                    }
                }
                .btn{
                    width: 14.1333vw;
                    height: 6.5333vw;
                    line-height: 6.5333vw;
                    font-size: 3vw;
                    border: 0.3vw solid #ff961c;
                    color: #ff961c;
                    border-radius: 2vw;
                }
            }
        }
    }
}
</style>